import React, { useEffect } from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { AllAppsetup, AllSocialLink } from '../../features/admin/footer/Slice';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import parse from "html-react-parser";
import { IDS } from '../../../src/utils/IDS';

const Footer = () => {

  const dispatch = useDispatch();

  const app_setup = useSelector((state) => state.footer.app_setup);
  const all_social_links = useSelector((state) => state.footer.all_social_links);

  // console.log("app_setupapp_setupapp_setupapp_setup",app_setup?.address)

  useEffect(() => {
    dispatch(AllAppsetup());
    dispatch(AllSocialLink());
  }, [dispatch]);
  return (
    <>
      <section className="footer_main">
        <div className="whitebox">

        </div>
        <div className="container-xl">
          <div className="footer_sec">
            <div className="logo_div">
              <Link to="/home">
                <div className="img_div">
                  <img className="footlogo" src={process.env.PUBLIC_URL + '/assets/images/logo/logo.png'} alt="Logo" />
                </div>
              </Link>
            </div>

            <div className="footcontsec">
              <div className="row">
                <div className="col-12 order-lg-1 order-2">
                  <div className="row">
                    <div className="col-lg-4 col-sm-6 order-lg-1 order-1 text-md-start">
                      <div className="coldata">
                        <h6 className="foothead">Address:</h6>
                        <p className="addp">{app_setup?.address}</p>

                        <h6 className="foothead">{app_setup?.timing}</h6>
                      </div>
                    </div>

                    <div className="col-lg-4 col-sm-12 order-lg-2 order-3 text-center ">
                      <div className="coldata">
                        <p className="midtext">{app_setup?.description}</p>


                        <div className="social_div">
                          {all_social_links?.map((item) => (
                            <Link key={item.id} to={item.url} target="_blank">
                              <img
                                className="icon"
                                src={`${IDS.IMG_URL + item?.image}`
                                } alt={item.name}
                              />
                            </Link>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-4 col-sm-6 order-lg-3 order-2 text-md-end text-start">
                      <div className="coldata">
                        <h6 className="foothead">Info:</h6>
                        <p className="infop"><b>Support :</b> {app_setup?.support}</p>
                        <p className="infop"><b>Email :</b> {app_setup?.email}</p>
                        <p className="infop"><b>Phone :</b> {app_setup?.contact_no}</p>
                      </div>
                    </div>

                  </div>
                </div>
                <div className="col-12 order-lg-2 order-1">
                  <div className="navmenuflex">
                    <div className="navmenu bd">
                      <Link to="/about-us">About Us</Link>
                    </div>
                    <div className="navmenu bd">
                      <Link to="/have-a-question">Have a question?</Link>
                    </div>
                    <div className="navmenu bd">
                      <Link to="/settings/donation-cancellation">Donation Cancellation & Refund Policy</Link>
                    </div>
                    <div className="navmenu bd">
                      <Link to="/settings/shipping-delivery-policy">Shipping & Delivery Policy</Link>
                    </div>
                    <div className="navmenu bd">
                      <Link to="/settings/privacy-policy">Privacy Policy</Link>
                    </div>
                    <div className="navmenu">
                      <Link to="/settings/terms-conditions">Terms & Conditions</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="copyright_div">
              <p className="copyright">©2025 Om Tapovan All rights reserved
                | Developed by <Link target="_blank" to="https://profcymaglobal.com/">Profcyma Solutions Pvt Ltd</Link></p>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
